import QrCode from 'qrcodejs'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      qrGenerator: (text: string) => {
        const matrix = QrCode.generate(text)

        return QrCode.render('svg-uri', matrix)
      },
    },
  }
})
